export const data = [
    {
        name:'AngryPill',
        emoji:'💊',
        desc: 'A Pill That will convert your anger into happiness',
        link:'https://angry-pill.netlify.app/',
    },
    {
        name:'Score Board',
        emoji:'🥇',
        desc: 'A Board that will help you to count the score & see who win',
        link:'https://score-board-developedbyjk.netlify.app/',
    },
    {
        name:'Restaurant App',
        emoji:'🍜',
        desc: 'Time to have Some Food. Join the jimmy restaurants',
        link:'https://restaurants-app-developedbyjk.netlify.app/',
    },
    {
        name:'2Success',
        emoji:'🏆',
        desc: 'Help to understand and navigate the different stages of life',
        link:'https://survival-to-success.netlify.app/',
    },
    {
        name:'Color Palette',
        emoji:'🎨',
        desc: 'Generate & Get Ideas for Awesome Color Palette Generator',
        link:'https://color-palette-generator-developedbyjk.netlify.app/',
    },
    {
        name:'Password Generator',
        emoji:'🔐',
        desc: 'Generate Fresh & Unique Password For Better Security',
        link:'https://passwordgenerator-developedbyjk.netlify.app/',
    }
]

